module.exports = __webpack_public_path__ + "img/Avatar-47.62804518.svg";